var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"fighter-video",attrs:{"width":"560","height":"315","src":`https://www.youtube.com/embed/${this.videoID}`,"frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope;","allowfullscreen":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }